/**
 * @generated SignedSource<<bf763f80963fa861b1d9b63ea76eb1e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type AccountRecordingDisclosureSendTo = "EXTERNAL" | "EXTERNAL_AND_NON_FELLOW_INTERNAL";
export type StreamRecordingDisclosureSettingsQuery$variables = {
  streamId: string;
};
export type StreamRecordingDisclosureSettingsQuery$data = {
  readonly account: {
    readonly recordingDisclosureSettings: {
      readonly allowUsersToToggleRecordingDisclosure: boolean;
      readonly sendTo: AccountRecordingDisclosureSendTo;
      readonly shouldSendRecordingDisclosureEmail: boolean;
    };
  };
  readonly stream: {
    readonly autoRecordSetting?: {
      readonly __typename: "NoteStreamUserSettingsBasedAutoRecordEnableSource";
      readonly cannotBeRecordedReason: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly id?: string;
    readonly recordingDisclosureSettings?: {
      readonly shouldSendRecordingDisclosureEmail: boolean;
    } | null;
  } | null;
};
export type StreamRecordingDisclosureSettingsQuery = {
  response: StreamRecordingDisclosureSettingsQuery$data;
  variables: StreamRecordingDisclosureSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "streamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shouldSendRecordingDisclosureEmail",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AccountRecordingDisclosureSettings",
  "kind": "LinkedField",
  "name": "recordingDisclosureSettings",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "allowUsersToToggleRecordingDisclosure",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sendTo",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "streamId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StreamRecordingDisclosureSettings",
  "kind": "LinkedField",
  "name": "recordingDisclosureSettings",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "autoRecordSetting",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cannotBeRecordedReason",
          "storageKey": null
        }
      ],
      "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
      "abstractKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamRecordingDisclosureSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "stream",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StreamRecordingDisclosureSettingsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "account",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "stream",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "type": "NoteStream",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5d8405f39ded8aeacad8dc4eceec6b8a",
    "id": null,
    "metadata": {},
    "name": "StreamRecordingDisclosureSettingsQuery",
    "operationKind": "query",
    "text": "query StreamRecordingDisclosureSettingsQuery(\n  $streamId: ID!\n) {\n  account {\n    recordingDisclosureSettings {\n      shouldSendRecordingDisclosureEmail\n      allowUsersToToggleRecordingDisclosure\n      sendTo\n    }\n    id\n  }\n  stream: node(id: $streamId) {\n    __typename\n    ... on NoteStream {\n      id\n      recordingDisclosureSettings {\n        shouldSendRecordingDisclosureEmail\n      }\n      autoRecordSetting {\n        __typename\n        ... on NoteStreamUserSettingsBasedAutoRecordEnableSource {\n          cannotBeRecordedReason\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e74ee87ee198b810824ab9dc271b1cfe";

export default node;
